


















import { defineComponent } from '@nuxtjs/composition-api'

export type SupportingDataProp = {
  key: string
  value: string
}

export default defineComponent({
  props: {
    data: {
      type: Array as () => SupportingDataProp[],
      default: () => [],
    },
    maxNumOfElements: {
      type: Number as () => number | undefined,
      default: undefined,
    },
  },
  setup() {
    return {}
  },
})
